"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../shadcn/ui/tooltip";

import { Info } from "lucide-react";
import { cn } from "@punchup/utils/cn";

export interface InfoTooltipProps {
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
}

export function InfoTooltip({
  children,
  className,
  iconClassName,
  side,
  align,
}: InfoTooltipProps) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info className={cn("h-4 w-4 shrink-0 cursor-help", iconClassName)} />
        </TooltipTrigger>
        <TooltipContent
          side={side}
          align={align}
          className={cn("max-w-xs text-primary-blue font-light", className)}
          collisionPadding={10}
        >
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
